import { createContext, useReducer, useEffect, useState } from 'react';
import storeReducer, { initialStore, types } from './storeReducer';
import socketIOClient from "socket.io-client";

const StoreContext = createContext();

const StoreProvider = ({children})=>{

    const [ store, dispatch ] = useReducer(storeReducer, initialStore);
    const [ socket, setSocket ] = useState()

    useEffect(()=>{
        // const socket_ = socketIOClient();
        // setSocket( socket_ )
        // socket_.on('SocketClientes', dataClientes => {   
        //     dispatch({type:types.clientsGet, payload:dataClientes}); 
        //     dispatch({type:types.renderClientes, payload:true}); 
        // });

        // socket_.on('SocketZonas', dataZonas => {   
        //     dispatch({type:types.zonesGet, payload:dataZonas});
        //     dispatch({type:types.renderInfo, payload:true});
        // });

        // socket_.on('SocketStocks', dataStock => {   
        //     dispatch({type:types.stockGet, payload:dataStock});
        //     dispatch({type:types.renderStock, payload:true}); 
        // });

        // socket_.on('SocketOts', dataOt => {   
        //     dispatch({type:types.otGet, payload:dataOt});
        //     dispatch({type:types.renderOts, payload:true}); 
        // });

        // socket_.on('SocketAdicionales', dataAdicional => {   
        //     dispatch({type:types.adicionalGet, payload:dataAdicional});
        //     dispatch({type:types.renderAdicionales, payload:true}); 
        // });

        // socket_.on('SocketDescuentos', dataDescuento => {   
        //     dispatch({type:types.descuentoGet, payload:dataDescuento});
        //     dispatch({type:types.renderDescuentos, payload:true}); 
        // });

        // socket_.on('SocketRecibos', dataRecibos => {   
        //     dispatch({type:types.recibosGet, payload:dataRecibos});
        //     dispatch({type:types.renderRecibos, payload:true}); 
        // });

        // socket_.on('SocketFacturas', dataFacturas => {   
        //     dispatch({type:types.facturasGet, payload:dataFacturas});
        //     dispatch({type:types.renderFacturas, payload:true}); 
        // });
        


    },[])

    useEffect(()=>{
        try{ 
            socket.on('connect', ()=>{
                dispatch({type:types.statusSocket, payload:true}); 
            })
        }catch(err){
            console.log(err)
        }
       
    },[socket]);

    useEffect(()=>{
        try{ 
            socket.on('disconnect', ()=>{
                dispatch({type:types.statusSocket, payload:false}); 
            })
        }catch(err){
            console.log(err)
        }
       
    },[socket]);
    

    
    
    return(
        <StoreContext.Provider value={[ store, dispatch ]}>
            {children}
        </StoreContext.Provider>
            
    )
};

export { StoreContext };
export default StoreProvider;